import React from "react";
import EventForTeam from "./eventForTeam";

import TeamInform from "../registerTeam/registerTeamForm";
import { Col, Row } from "react-bootstrap";
import { Box } from "@material-ui/core";

export default ({
  events,
  eventId,
  handleTeamChange,
  number,
  carValues,
  racingBracket,
  handleImageChange,
  image,
  handleCreateTeam,
  team,
}) => {
  return (
    <div>
      <Box className="fontStyleHeadingProfile" border="1px solid #DCDCDC" p={1}>
        Create Team
      </Box>

      {Array.isArray(events) && (
        <Col lg={12} xs={12} sm={12} md={12} xl={12}>
          <Box position="relative">
            <Box mt={2} width="100%">
              <Row className="rowProfileScreen">
                <Col>
                  <EventForTeam
                    events={events}
                    eventId={eventId}
                    handleTeamChange={handleTeamChange}
                  />
                </Col>
              </Row>
            </Box>
            <Box>
              <TeamInform
                handleImageChange={handleImageChange}
                carValues={carValues}
                image={image}
                team={team}
                racingBracket={racingBracket}
                eventId={eventId}
                number={number}
                handleCreateTeam={handleCreateTeam}
              />
            </Box>
          </Box>
        </Col>
      )}
    </div>
  );
};
